import { AppStore, getAppSelection } from '@alfresco/aca-shared/store';
import { ExtensionLoaderService, ExtensionService } from '@alfresco/adf-extensions';
import { NodeEntry } from '@alfresco/js-api';
import { Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Component({
  templateUrl: './custom-action.component.html',
  styleUrls: ['./custom-action.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class CustomActionComponent implements OnDestroy {

  @Input() id: string;
  @Input() data: { title?: string; image?: boolean, icon?: string, action?: string }

  onDestroy$: Subject<boolean> = new Subject();
  loading: boolean;

  nodeEntry: NodeEntry;

  constructor(
    protected extensionService: ExtensionService,
    protected store: Store<AppStore>,
    protected loader: ExtensionLoaderService,
  ) { }

  ngOnDestroy(): void {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  handleAction(actionId: string) {
    if(actionId) {
      this.store.select(getAppSelection).pipe(take(1)).subscribe((selection) => {
        this.store.dispatch({ type: actionId, selection: selection });
      });  
    }
  }

}
